import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import './Login.scss';
import logo from 'src/assets/images/logo.png';
import Form from 'src/components/Form/Form';
import Button from 'src/components/Button/Button';

export default function Login() {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const [tillCode, setTillCode] = useState(null);
  const [tillData, setTillData] = useState(null);

  const loadTillId = async () => {

    const { tillId, systemId, localIp, vpnIp } =  await dispatch.peripherals.getTillId();

    setTillData({ tillId, systemId, localIp, vpnIp });

    if (tillId === 0){
      localStorage.setItem('fakeTill', 'true');
    } else if (!localStorage.getItem('tillId') || localStorage.getItem('tillId') !== tillId.toString()){
      localStorage.setItem('tillId', tillId);
    }
    setTillCode(tillId);
  };

  useEffect(() => {
    let refreshInterval;

    if (localStorage.getItem('retail')){
      loadTillId();
      refreshInterval = setInterval(() => {

        if (tillCode === 0){
          clearInterval(refreshInterval);
        } else {
          if ((tillCode === -1 || !tillCode) && tillCode !== 0){
            loadTillId();
          }
        }
      }, 10000);
    }

    return () => {
      clearInterval(refreshInterval);
    };
  }, [tillCode]);

  const steps = [
    {
      inputs: [
        {
          type: 'text',
          className: 'full-width',
          label: `${ t('form.usernameLabel') }:`,
          name: 'username',
          value: '',
          disabled: false,
          required: true,
          hidden: false,
          horizontal: true
        },
        {
          type: 'password',
          className: 'full-width',
          label: `${ t('form.passwordLabel') }:`,
          name: 'password',
          required: true,
          hideIcon: true,
          hidden: false,
          horizontal: true
        }
      ],
      buttons: [
        {
          type: 'submit',
          label: t('form.loginButton')
        }
      ],
      links: [
        {
          text: t('form.loginForgotPassword'),
          action: 'recover-password',
          className: 'full-width',
          decoration: true
        }
      ]
    }
  ];

  if (localStorage.getItem('retail')) {

    steps[0].inputs.unshift({
      type: 'text',
      className: 'full-width',
      label: `${ t('form.tillLabel') }:`,
      value: '',
      name: 'till',
      hidden: tillCode === 0 ? false : true,
      disabled: false,
      required: true,
      horizontal: true
    });
  }

  const reboot = async (type) => {

    const username = (document.getElementsByName('username')[0] as HTMLInputElement).value;
    const password = (document.getElementsByName('password')[0] as HTMLInputElement).value;
    const till = (document.getElementsByName('till')[0] as HTMLInputElement).value;
    const reboot = type === 'reboot';

    await dispatch.auth.reboot({ username, till, password, reboot });
  };

  if (tillCode >= 0){
    return (
      <div className="login-container">
        <div className="login-page">
          <div className="login-page__logo">
            <img src={ logo } alt="Logo" />
          </div>

          <div className="login-page__form-container">
            <Form
              containerClass={ localStorage.getItem('retail') ? 'tillLogin-form' : 'tradingLogin-form' }
              steps={ steps }
            />
          </div>
          {
            localStorage.getItem('retail') &&
          <>
            <div className="login-page__environment">
              { window.location.hostname }
              {
                (tillData && tillData.tillId > 0) &&
                (<div>
                  <span>{ `${ t('retail.tillId') }: ` }</span>{ tillData.tillId }
                </div>)
              }
              { (tillData && tillData.systemId) && <div><span>{ `${ t('retail.systemId') }: ` }</span>{ tillData.systemId }</div> }
              { (tillData && tillData.localIp) && <div><span>{ `${ t('retail.localIp') }: ` }</span>{ tillData.localIp }</div> }
              { (tillData && tillData.vpnIp) && <div><span>{ `${ t('retail.vpnIp') }: ` }</span>{ tillData.vpnIp }</div> }
            </div>
            <div className="login-page__reboot-container">
              <Button className="btn btn--cta login-page__reboot-button" onClick={ () => reboot('turnoff') } text={ t('retail.turnOff') } />
              <Button className="btn btn--cta login-page__reboot-button" onClick={ () => reboot('reboot') } text={ t('retail.reboot') }  />
            </div>
          </>
          }
        </div>
      </div>
    );
  } else if (tillCode === -1){
    return (
      <div className="login-container">
        <div className="login-page">
          <div className="login-page__logo">
            <img src={ logo } alt="Logo" />
            <div className="login-page__mode">
              { localStorage.getItem('retail') ? t('tillMode') : t('tradingMode') }
            </div>
            <div className="login-page__error">
              { t('retail.noTillFound') }
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="login-container">
        <div className="login-page" />
      </div>
    );
  }
}
